export const CANONICAL_CONTROL_PROPS = Object.freeze({
  outlined: true,
  dense: true,
  hideBottomSpace: false
})

export function requiredRule(message = 'Обязательное поле') {
  return (value) => {
    if (typeof value === 'string') return value.trim().length > 0 || message
    return (value !== null && value !== undefined && value !== '') || message
  }
}

export function documentNumberRule(value) {
  const match = String(value ?? '').trim().match(/^([+-]?)([0-9]+)$/)
  if (!match) return 'Номер документа должен быть целым числом'
  const digits = match[2].replace(/^0+/, '') || '0'
  const limit = match[1] === '-' ? '9223372036854775808' : '9223372036854775807'
  return digits.length < limit.length || (digits.length === limit.length && digits <= limit) || 'Номер документа слишком большой'
}

export function clearValidationAnnotations(root) {
  if (!root || typeof root.querySelectorAll !== 'function') return
  root.querySelectorAll('[data-sid-validation-control="true"]').forEach((control) => {
    control.removeAttribute('aria-invalid')
    const describedBy = String(control.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter((id) => id && !id.startsWith('sid-field-error-'))
    if (describedBy.length) control.setAttribute('aria-describedby', describedBy.join(' '))
    else control.removeAttribute('aria-describedby')
    control.removeAttribute('data-sid-validation-control')
  })
  root.querySelectorAll('[data-sid-validation-message="true"]').forEach((message) => {
    message.removeAttribute('data-sid-validation-message')
    if (message.id.startsWith('sid-field-error-')) message.removeAttribute('id')
  })
}

export function annotateValidationErrors(root) {
  if (!root || typeof root.querySelectorAll !== 'function') return
  clearValidationAnnotations(root)
  root.querySelectorAll('.q-field--error').forEach((field, index) => {
    const control = field.querySelector(
      'input:not([type="hidden"]), textarea, [role="combobox"], [role="textbox"], [tabindex]:not([tabindex="-1"])'
    )
    const messages = [...field.querySelectorAll('.q-field__messages')]
    const message = messages.find((item) => (
      String(item.textContent || '').trim() && !item.classList.contains('q-transition--field-message-leave-active')
    )) || messages[messages.length - 1]
    if (!control || !message) return
    const id = `sid-field-error-${index + 1}`
    message.id = id
    message.dataset.sidValidationMessage = 'true'
    control.setAttribute('aria-invalid', 'true')
    control.dataset.sidValidationControl = 'true'
    const describedBy = new Set(
      String(control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean)
    )
    describedBy.add(id)
    control.setAttribute('aria-describedby', [...describedBy].join(' '))
  })
}

export async function validateAndFocus(form, root) {
  if (!form) return false
  const valid = await form.validate()
  const container = root && root.$el ? root.$el : root
  if (valid) {
    clearValidationAnnotations(container)
    return true
  }
  annotateValidationErrors(container)
  const invalidControl = container && container.querySelector(
    '.q-field--error input, .q-field--error textarea, .q-field--error [tabindex]:not([tabindex="-1"])'
  )
  if (invalidControl) invalidControl.focus({ preventScroll: true })
  return false
}

export function createDirtyLeaveGuard(options = {}) {
  const dirtyKey = options.dirtyKey || 'isDirty'
  const requestMethod = options.requestMethod || 'requestDirtyLeave'

  return function dirtyLeaveGuard(to, from, next) {
    if (!this[dirtyKey]) {
      next()
      return
    }
    this[requestMethod](next, to, from)
  }
}
